export type FieldError = {
  message: string;
  errorMessage?: string;
  messageTemplate:
    | 'incorrect_password'
    | 'already_exists_in_db'
    | 'incorrect_code'
    | 'invalid_phone_number'
    | 'invalid_credentials'
    | 'card_not_usable'
    | 'Forbidden'
    | 'CLIENT_NOT_FOUND'; // NOTE: This template doesn't come from BE. Used for login field errors
  property?: string;
  status?: number;
};

class ValidationError extends Error {
  fieldErrors: FieldError[];

  constructor(fieldErrors: FieldError[]) {
    super('ValidationError');
    this.name = 'ValidationError';
    this.fieldErrors = fieldErrors;
  }
}

export default ValidationError;
